import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO } from "@/lib/data";

const LINKS = [
  { label: "Home", to: "/", hash: "" },
  { label: "About", to: "/", hash: "#about" },
  { label: "Services", to: "/", hash: "#services" },
  { label: "Knowledge Bank", to: "/knowledge", hash: "" },
  { label: "Team", to: "/", hash: "#team" },
  { label: "Contact", to: "/contact", hash: "" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (link) => {
    setOpen(false);
    const scrollToHash = (hash) => {
      const el = document.querySelector(hash);
      if (!el) return;
      if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
      else el.scrollIntoView({ behavior: "smooth" });
    };
    if (link.hash) {
      if (location.pathname !== "/") {
        navigate("/" + link.hash);
      } else {
        scrollToHash(link.hash);
      }
    } else {
      navigate(link.to);
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      else window.scrollTo({ top: 0 });
    }
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 w-full z-50 transition-colors duration-300 border-b ${
        scrolled ? "backdrop-blur-2xl bg-background/80 border-border/50" : "bg-transparent border-transparent"
      }`}
    >
      <nav className="container-edge flex items-center justify-between h-24">
        <button
          data-testid="logo-home-btn"
          onClick={() => go({ to: "/" })}
          className="flex items-center gap-3"
        >
          <img src={LOGO} alt="IPNOMICS LLP" className="h-16 w-16 object-contain" />
          <span className="font-display text-3xl tracking-tight text-primary leading-none">
            IPNOMICS<span className="text-accent"> LLP</span>
          </span>
        </button>

        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => go(l)}
              className="text-sm text-foreground/80 hover:text-accent transition-colors duration-200 tracking-wide"
            >
              {l.label}
            </button>
          ))}
          <button data-testid="nav-cta-contact" onClick={() => go({ to: "/contact" })} className="btn-primary py-3 px-6">
            Get In Touch
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-primary"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-background border-t border-border">
          <div className="container-edge py-6 flex flex-col gap-4">
            {LINKS.map((l) => (
              <button
                key={l.label}
                onClick={() => go(l)}
                className="text-left text-base text-foreground/80 hover:text-accent py-1"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
